import { ActionTree } from "vuex";
import { AuthenticationState, UserResourceClaims, UserAutoSettings } from "./types";
import { RootState } from "@/store/types";
import { login, azureLogin, azureLogout, adminLogin, configAutoLogout, impersonate, cancelImpersonation } from "@/services/security/authService";
import { updateUserAutoSettings } from "@/services/users/usersService";

export const actions: ActionTree<AuthenticationState, RootState> = {
    loginAction({ commit, dispatch }, user) {
        return new Promise((resolve, reject) => {
            login(user)
                .then((response: any) => {
                    commit("authSuccess", response.data);
                    dispatch("render/setAllowedOrigins", response.data.allowedOrigins, { root: true });
                    dispatch("loadAllowStockImages", null, { root: true });
                    configAutoLogout();
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    },
    adminLoginAction({ commit, dispatch }, token: string) {
        return new Promise((resolve, reject) => {
            commit("authClear");
            adminLogin(token)
                .then((response: any) => {
                    commit("authSuccess", response.data);
                    dispatch("render/setAllowedOrigins", response.data.allowedOrigins, { root: true });
                    dispatch("loadAllowStockImages", null, { root: true });
                    configAutoLogout();
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    },
    azureLoginAction({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            azureLogin()
                .then((response: any) => {
                    commit("authSuccess", response.data);
                    dispatch("render/setAllowedOrigins", response.data.allowedOrigins, { root: true });
                    dispatch("loadAllowStockImages", null, { root: true });
                    configAutoLogout();
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    },
    impersonateAction({ commit, dispatch }, userId) {
        return new Promise((resolve, reject) => {
            impersonate(userId)
                .then((response: any) => {
                    commit("authSuccess", response.data);
                    configAutoLogout();
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    },
    cancelImpersonationAction({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            cancelImpersonation()
                .then((response: any) => {
                    commit("authSuccess", response.data);
                    configAutoLogout();
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    },
    logoutAction({ commit, state }) {
        if (state.currentUser.isRegularUser) {
            commit("authClear");
        } else {
            azureLogout().then(() => {
                commit("authClear");
            });
        }
    },
    updateUserResourceClaims({ commit }, userResourceClaims: Array<UserResourceClaims>) {
        commit("updateUserResourceClaims", userResourceClaims);
    },
    validateToken({ commit, state }) {
        if (state.tokenValidTo != null) {
            const tokenValidTo: Date = new Date(state.tokenValidTo);
            if (tokenValidTo < new Date()) {
                commit("authClear");
            }
        } else {
            commit("authClear");
        }
    },
    updateUserAutoSettings({ commit }, userAutoSettings: UserAutoSettings) {
        commit("updateUserAutoSettings", userAutoSettings);
        updateUserAutoSettings(userAutoSettings).then(() => { });
    }
};
